import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { OAuthUserInfo } from '../models/oauthuserinfo.model';
import { RelationshipManager } from '../models/relationship-manager.model';
import { ApiService } from './api.service';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  private userInfosSubscription: Subscription;
  private userSub: string;
  
  constructor(private apiService: ApiService, private sessionStorage: SessionStorageService) {
    this.userInfosSubscription = this.sessionStorage.userInfosChange.subscribe( (data: string) => {
      let userInfo: OAuthUserInfo = <OAuthUserInfo>JSON.parse(data);
      if (userInfo) {
        this.userSub = userInfo.sub;
      }
    });
  }

  public getRelationshipManagers(): Promise<Array<RelationshipManager>> {
    if(!this.userSub) return;

    return this.apiService.get(`/company/relationship-managers/${this.userSub}`);
  }
}
